import React from "react";

const OptionPlaceholder = ({ children }) => (
  <option value={""} hidden>
    {children}
  </option>
);

export default OptionPlaceholder;
